"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;

var _react = _interopRequireDefault(require("react"));

function Header(props) {
  var title = props.title,
      subtitle = props.subtitle,
      tags = props.tags;
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: "FlexDropdownCardHeader"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "tags"
  }, tags && (Array.isArray(tags) ? tags.map(function (tag, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "tag",
      key: "FlexDropdownCardHeaderTag-" + idx
    }, tag);
  }) : /*#__PURE__*/_react["default"].createElement("li", {
    className: "tag"
  }, tags))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "subtitle"
  }, subtitle));
}